import React from 'react'
import PackageIssueReportPage from './PackageIssueReportPage'
import '../styles/_index.scss'

const PackageIssueReportContainer = () => {
    return (
        <div className='PackageIssueReportContainer'>
            <PackageIssueReportPage />
        </div>
    )
}

export default PackageIssueReportContainer